import {
	Component, HostBinding
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../animations/page-transitions';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { BackButtonComponent } from '../back-button/back-button.component';

import { ECallOffWidgetComponent } from './ecall-off-widget.component';

@Component({
	selector: 'copo-order-services-menu',
	templateUrl: './order-services-menu.component.html',
	animations: pageTransitions,
	imports: [BackButtonComponent, TranslateModule, ECallOffWidgetComponent]
})

export class OrderServicesMenuComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;
	user: User;
	canCallByVolume = false;

	constructor(
		private readonly userService: UserService,
	) {
		this.user = this.userService.user;
		this.canCallByVolume = this.userService.user.hasServiceParameterEqualsTo('PCALL', 'ByVolume', 'True');
	}
}
